import { Component, Input, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

import { DsModule } from '@levelaccess/design-system';
import { PortfolioSharedModule } from '../../portfolio/portfolio-shared.module';
import { CommonPipesModule } from '../../../../shared/common-pipes.module';
import { IDigitalProperty } from '../../../../../../shared/interfaces/digital-property.interface';
import { FeatureFlagService } from '../../../../services/feature-flag/feature-flag.service';
import { FeatureFlagCollection } from '../../../../../../shared/interfaces/feature-flag.interface';

@Component({
  selector: 'app-add-digital-properties-modal',
  templateUrl: './add-digital-properties-modal.component.html',
  styleUrl: './add-digital-properties-modal.component.scss',
  imports: [CommonModule, PortfolioSharedModule, DsModule, CommonPipesModule],
})
export class AddDigitalPropertiesModalComponent {
  @Input() tenantId: string;

  public readonly digitalAssetFormUpdateEnabled: Signal<boolean> = toSignal(
    this.featureFlagService.variation$(FeatureFlagCollection.digitalAssetFormUpdate, false).pipe(map(Boolean)),
    { initialValue: false },
  );

  constructor(
    public modal: NgbActiveModal,
    private featureFlagService: FeatureFlagService,
  ) {}

  public onDigitalPropertyAdded(addedDigitalProperty?: IDigitalProperty): void {
    this.modal.close(addedDigitalProperty);
  }

  public onCancel(): void {
    this.modal.dismiss();
  }
}
